export default __webpack_public_path__ + "media/images/portfolio/gallery-04-370x220-12fea75381d914e8767123a25afcabae.jpg";